import { ConfigModule } from '../models/ConfigModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function GetConfigModulesCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async getAllModulesConfig(patientId: string): Promise<ConfigModule> {
      return await configClientRepository.getAllModulesConfig(patientId)
    }
  }
}
